<template>
  <modal :show.sync="internalShow" @close="handleClose" size="lg">
    <template #header>
      <div>
        <div class="text-xl font-semibold text-slate-900">Payment History</div>
        <div class="mt-1 text-sm text-slate-500">
          <span>{{ invoiceLabel }}</span>
          <span v-if="firm" class="mx-1.5 text-slate-300">·</span>
          <span v-if="firm">{{ firm }}</span>
        </div>
      </div>
    </template>

    <div class="payment-history-popup">
      <div v-if="loading" class="py-10 text-sm text-center text-slate-500">
        Loading transactions…
      </div>

      <div
        v-else-if="!transactions.length"
        class="p-6 text-sm text-center text-slate-500 bg-slate-50 rounded-lg border border-dashed border-slate-200"
      >
        No payment transactions found for this invoice.
      </div>

      <div v-else>
        <div class="overflow-x-auto rounded-lg border border-slate-200">
          <table class="min-w-full text-sm">
            <thead class="bg-slate-100 text-slate-700">
              <tr>
                <th class="px-3 py-2 font-semibold text-left">Date</th>
                <th class="px-3 py-2 font-semibold text-left">Collected By</th>
                <th class="px-3 py-2 font-semibold text-left">Payment Mode</th>
                <th class="px-3 py-2 font-semibold text-right">Amount</th>
                <th class="px-3 py-2 font-semibold text-left">Note</th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-slate-100">
              <tr
                v-for="tx in transactions"
                :key="tx.id"
                class="hover:bg-slate-50"
              >
                <td class="px-3 py-2 whitespace-nowrap text-slate-800">
                  {{ formatDate(tx.date) }}
                </td>
                <td class="px-3 py-2 text-slate-700 capitalize">
                  {{ tx.collectedBy || "—" }}
                </td>
                <td class="px-3 py-2 text-slate-700">
                  {{ tx.paymentMode }}
                  <span
                    v-if="tx.isAdvance"
                    class="ml-1 inline-flex px-1.5 py-0.5 text-xs font-medium text-blue-800 bg-blue-100 rounded"
                  >
                    Advance
                  </span>
                </td>
                <td class="px-3 py-2 font-medium text-right text-green-700 whitespace-nowrap">
                  {{ tx.amount | currency }}
                </td>
                <td class="px-3 py-2 text-slate-500">
                  {{ tx.paymentNote || "—" }}
                </td>
              </tr>
            </tbody>
            <tfoot class="bg-slate-50">
              <tr>
                <td colspan="3" class="px-3 py-2 text-sm font-semibold text-right text-slate-700">
                  Total received
                </td>
                <td class="px-3 py-2 text-sm font-bold text-right text-green-700">
                  {{ totalReceived | currency }}
                </td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>

    <template #footer>
      <div class="flex justify-end">
        <button
          type="button"
          class="px-4 py-2 text-sm bg-white rounded border border-gray-300 hover:bg-gray-50"
          @click="handleClose"
        >
          Close
        </button>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";

export default {
  name: "PaymentHistoryPopup",
  components: { Modal },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    identifier: {
      type: String,
      default: ""
    },
    firm: {
      type: String,
      default: ""
    },
    transactions: {
      type: Array,
      default: () => []
    },
    totalReceived: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      internalShow: this.show
    };
  },
  computed: {
    invoiceLabel() {
      return this.identifier ? `Invoice ${this.identifier}` : "Invoice";
    }
  },
  watch: {
    show(val) {
      this.internalShow = val;
    },
    internalShow(val) {
      if (!val) this.$emit("update:show", false);
    }
  },
  methods: {
    handleClose() {
      this.internalShow = false;
      this.$emit("close");
    },
    formatDate(date) {
      if (!date) return "—";
      const d = new Date(date);
      if (Number.isNaN(d.getTime())) return String(date);
      return d.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      });
    }
  },
  filters: {
    currency(value) {
      const amount = parseFloat(value) || 0;
      return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR"
      }).format(amount);
    }
  }
};
</script>

<style scoped>
.payment-history-popup {
  max-height: 60vh;
  overflow-y: auto;
}
</style>
